"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.385 1.437a4.529 4.529 0 0 0-3.28-1.09c-1.19.08-2.3.63-3.1 1.52a4.61 4.61 0 0 0-3.1-1.52c-1.19-.09-2.37.3-3.29 1.08-.92.78-1.5 1.9-1.59 3.11-.1 1.21.28 2.41 1.07 3.33l6.26 7.41.27.32a.515.515 0 0 0 .38.18c.07 0 .15-.02.21-.05.07-.03.13-.08.17-.13l6.53-7.72c.78-.92 1.17-2.12 1.07-3.33-.1-1.21-.67-2.33-1.6-3.11Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.787 6.75a6.663 6.663 0 0 0-2.325-4.538A6.653 6.653 0 0 0 16.595.637a6.682 6.682 0 0 0-4.553 2.325l-.045.053-.037-.053a6.659 6.659 0 0 0-9.405-.787 6.68 6.68 0 0 0-2.34 4.537 6.652 6.652 0 0 0 1.56 4.868l9.487 11.235.308.36c.052.06.12.112.187.15a.533.533 0 0 0 .24.052.657.657 0 0 0 .24-.052.545.545 0 0 0 .195-.15l9.795-11.573a6.699 6.699 0 0 0 1.56-4.86v.008Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    d: "M31.716 9a8.884 8.884 0 0 0-3.1-6.05 8.87 8.87 0 0 0-6.49-2.1 8.91 8.91 0 0 0-6.07 3.1l-.06.07-.05-.07A8.878 8.878 0 0 0 3.406 2.9a8.907 8.907 0 0 0-3.12 6.05c-.2 2.35.55 4.69 2.08 6.49l12.65 14.98.41.48c.07.08.16.15.25.2.1.05.21.07.32.07.11 0 .22-.03.32-.07.1-.05.19-.11.26-.2l13.06-15.43a8.932 8.932 0 0 0 2.08-6.48V9Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    d: "M47.766 13.34a13.39 13.39 0 0 0-2.858-7.214 13.338 13.338 0 0 0-6.382-4.41 13.415 13.415 0 0 0-7.763-.12 13.368 13.368 0 0 0-6.517 4.215l-.248.285-.247-.285a13.314 13.314 0 0 0-9.023-4.388 13.387 13.387 0 0 0-9.525 3.128 13.37 13.37 0 0 0-4.665 8.88c-.345 3.45.66 6.9 2.813 9.622l19.402 22.95.518.608c.09.105.195.187.322.24.128.052.255.082.39.082s.27-.03.39-.082c.12-.053.233-.143.323-.24L44.63 23.083a13.328 13.328 0 0 0 2.542-4.56c.54-1.672.743-3.435.593-5.182Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    d: "M63.687 17.788c-.29-3.51-1.62-6.86-3.81-9.62a17.784 17.784 0 0 0-8.51-5.88 17.887 17.887 0 0 0-10.35-.16c-3.39.97-6.41 2.93-8.69 5.62l-.33.38-.33-.38c-3.1-3.45-7.41-5.54-12.03-5.85a17.85 17.85 0 0 0-12.7 4.17 17.828 17.828 0 0 0-6.22 11.84c-.46 4.6.88 9.2 3.75 12.83l25.87 30.6.69.81c.12.14.26.25.43.32.17.07.34.11.52.11s.36-.04.52-.11c.16-.07.31-.19.43-.32l26.58-31.37a17.77 17.77 0 0 0 3.39-6.08c.72-2.23.99-4.58.79-6.91Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconHeartFilled = function IconHeartFilled(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Heart Filled' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "HeartFilled"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconHeartFilled.sizes = [16, 24, 32, 48, 64];
IconHeartFilled.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconHeartFilled;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/system/HeartFilled.js
// module id = 2386
// module chunks = 0